const notificationType = {
    REGULAR : 0,

    CHAT : 1

};

angular.module('gw-um-j2js')
    .constant('notificationType', notificationType);